<template>
  <v-card class="mx-auto mt-2" color="white" flat>
    <v-card-text>
      <v-row v-if="!onMobile" class="row-header">
        <v-col cols="4" class="col2"></v-col>
        <v-col cols="2" class="col2 text-center">Yearly</v-col>
        <v-col cols="2" class="col2 text-center">Monthly</v-col>
        <v-col cols="2" class="col2 text-center">Weekly</v-col>
        <v-col cols="2" class="col1 text-center">Daily</v-col>
      </v-row>
      <v-row v-else class="row-header">
        <v-col cols="4" class="col2"></v-col>
        <v-col cols="4" class="col2 text-center">Yearly</v-col>
        <v-col cols="4" class="col2 text-center">Monthly</v-col>
      </v-row>

      <panel-row class="row-a" rowHeader="Gross Income" :cb="grossincome"></panel-row>
      <panel-row class="row-b row-taxable-income" rowHeader="Taxable Income" :cb="taxableIncome"></panel-row>
      <panel-row class="row-a" rowHeader="Income Tax" :cb="incometax"></panel-row>
      <panel-row class="row-b" rowHeader="National Insurance" :cb="natInsurance"></panel-row>
      <panel-row class="row-a" rowHeader="Total Tax" :cb="tax"></panel-row>
      <panel-row class="row-takehome" rowHeader="Take Home" :cb="takehome"></panel-row>
    </v-card-text>

    <v-card class="ma-0" color="#ffdf0038" flat>
      <v-card-text>
        <p>Your take-home pay is calculated by taking the Taxable Income and deducting Income Tax and National Insurance from it.</p>
        <p>
          Your Taxable Income is calculated by taking off your tax free allowance from your gross income. Personal allowance
          for the current tax year is £12,500.
        </p>
        <p v-if="isOver100">
          <span>NOTE: An income of over £100k will cause your allowance to be reduced at a rate of £1 for every £2 earned until the allowance is depleted.</span>
          Since the specified gross income is {{ grossincome("yearly") }} your allowance
          has decreased by {{ decreasedBy }} to {{ adjustedAllowance }} so your taxable income is now {{ taxableIncome("yearly") }}.
        </p>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import PanelRow from "./PanelTableDisplayRow";
import { FormatInfo, formatNumber } from "../utils";

let fiA = new FormatInfo("yearly", 2, true, "normal");

export default {
  components: {
    PanelRow
  },

  data() {
    return {
      slider: 45
    };
  },

  methods: {
    grossincome(period) {
      fiA.period = period;
      return this.$store.getters.getData(fiA, "grossIncome");
    },
    taxableIncome(period) {
      fiA.period = period;
      return this.$store.getters.getData(fiA, "taxableIncome");
    },
    incometax(period) {
      fiA.period = period;
      return this.$store.getters.getData(fiA, "totalIncomeTax");
    },
    tax(period) {
      fiA.period = period;
      return this.$store.getters.getData(fiA, "totalTax");
    },
    natInsurance(period) {
      fiA.period = period;
      return this.$store.getters.getData(fiA, "totalNI");
    },
    takehome(period) {
      fiA.period = period;
      return this.$store.getters.getData(fiA, "takeHome");
    }
  },

  computed: {
    getAA() {
      //return "hll";
      return this.$store.getters.getGrossIncome("");
    },
    onMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isOver100() {
      let xx = this.$store.getters.getGrossIncome("yearly", 0, false);
      return xx > 100000;
    },
    adjustedAllowance() {
      //let xx = this.$store.getters.getData(fiA, "allowanceAdjusted");
      let allowanceAdjusted = this.$store.getters.getAllowanceAdjusted;
      return formatNumber(allowanceAdjusted, 0, false);
    },
    decreasedBy() {
      let allowanceBase = this.$store.getters.getAllowanceBase;
      let allowanceAdjusted = this.$store.getters.getAllowanceAdjusted;
      return formatNumber(allowanceBase - allowanceAdjusted, 0, false);
    }
  }
};
</script>

<style lang="scss" scoped>
.col2 {
  border-right: 1px solid white;
}
.row-a {
  background-color: #f1f1f1;
  border-left: 1px solid lightgray;
}
.row-b {
  background-color: #f9fbed;
  border-left: 1px solid lightgray;
}
.row-header {
  background-color: #d0d0d0;
  border-left: 1px solid lightgray;
  border-top: 1px solid lightgray;
}
.row-takehome {
  background-color: #ffff00;
  /* border-left: 1px solid lightgray;
  border-bottom: 1px solid lightgray; */
  border: 1px solid red;
}

/* .row-taxable-income {
  background-color: #ffffeb98;
  border: 1px solid rgb(185, 197, 74);
} */
</style>